/* Tartan Plaid: easier filters (Kalles facets). Added 2026-10-29.
   - Groups with more than 10 values get a search box, and show the first
     10 values (6 on phones) with a "Show all" link instead of a small
     scroll box.
   - Phones: 44px tap rows, the filter drawer stays open after each tap,
     and a bar at the bottom shows "Show N products" and "Clear all".
   Works in the sidebar and both filter drawers, and comes back after the
   theme reloads the filters by AJAX. */
(function () {
  'use strict';
  if (window.__tpFilterSearch) return;
  window.__tpFilterSearch = true;

  var MIN_VALUES = 11;
  var SHOW_DESKTOP = 10;
  var SHOW_PHONE = 6;
  var LIST_SEL = 'ul.t4s-filter__values';
  var phoneMQ = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  var queries = {};
  var expanded = {};
  var boxes = [];
  var refocus = null;
  var keepOpenOnce = false;
  var loadingTimer = null;
  var uid = 0;

  function isPhone() { return !!(phoneMQ && phoneMQ.matches); }

  function scopeOf(el) {
    return el.closest('.t4s-drawer, #t4s-filter-hidden, aside') || document.body;
  }

  function onScreen(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.right > 0 && r.left < window.innerWidth;
  }

  var icon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2.2' stroke-linecap='round'%3E%3Ccircle cx='11' cy='11' r='7'/%3E%3Cpath d='M20 20l-3.6-3.6'/%3E%3C/svg%3E";
  var css = [
    '.tp-fs{position:relative;margin:0 0 8px}',
    '.tp-fs *,.tp-fs-footer *,button.tp-fs__more{box-sizing:border-box}',
    '.tp-fs .tp-fs__input{display:block;width:100%;height:38px;margin:0;padding:0 36px 0 34px;border:1px solid #d7d7d7;border-radius:4px;background:#fff url("' + icon + '") no-repeat 11px 50%;background-size:15px 15px;font-size:14px;line-height:normal;color:#222;box-shadow:none;outline:none;-webkit-appearance:none;appearance:none}',
    '.tp-fs .tp-fs__input:focus{border-color:#222}',
    '.tp-fs .tp-fs__input::placeholder{color:#8a8a8a;opacity:1}',
    '.tp-fs .tp-fs__clear{position:absolute;top:50%;right:4px;width:30px;height:30px;margin:-15px 0 0;padding:0;border:0;background:none;color:#666;font-size:20px;line-height:30px;text-align:center;cursor:pointer;min-width:0}',
    '.tp-fs .tp-fs__clear[hidden]{display:none}',
    '.tp-fs__count{margin:-2px 0 6px;font-size:12px;line-height:1.4;color:#757575}',
    '.tp-fs__count:empty{display:none}',
    '.tp-fs__empty{margin:4px 0 0;font-size:13px;line-height:1.4;color:#757575}',
    '.tp-fs__empty[hidden]{display:none}',
    'ul.tp-fs-list{max-height:none!important;overflow:visible!important}',
    'li.tp-fs-hide,li.tp-fs-cut{display:none!important}',
    'li.tp-fs-fade{-webkit-mask-image:linear-gradient(to bottom,#000 35%,rgba(0,0,0,.4));mask-image:linear-gradient(to bottom,#000 35%,rgba(0,0,0,.4))}',
    'mark.tp-fs-hl{background:#fde7a6;color:inherit;font-weight:inherit;padding:0;border-radius:2px}',
    '.tp-fs .tp-fs__more,button.tp-fs__more{display:inline-flex;align-items:center;gap:6px;margin:4px 0 0;padding:6px 0;border:0;background:none;color:#222;font-size:13px;font-weight:600;line-height:1.3;text-decoration:underline;text-underline-offset:3px;cursor:pointer;min-width:0;min-height:0;text-transform:none;letter-spacing:0}',
    'button.tp-fs__more[hidden]{display:none}',
    '.tp-fs__more-ico{display:inline-block;width:12px;text-align:center;text-decoration:none;font-weight:700}',
    'ul.t4s-filter__values .t4s-checkbox-wrapper{border-color:#8f8f8f}',
    '.tp-fs-footer{display:none}',
    '@media (max-width:767px){',
    'ul.t4s-filter__values.is--style-checkbox{max-height:none!important;overflow:visible!important}',
    'ul.t4s-filter__values.is--style-checkbox>li{margin:0!important}',
    'ul.t4s-filter__values.is--style-checkbox>li>a{min-height:44px;padding-top:4px;padding-bottom:4px}',
    'ul.t4s-filter__values .t4s-checkbox-wrapper{width:18px;height:18px}',
    '.tp-fs .tp-fs__input{height:44px;padding-right:46px;font-size:16px}',
    '.tp-fs .tp-fs__clear{right:0;width:44px;height:44px;margin-top:-22px}',
    'button.tp-fs__more{min-height:44px;margin:0;font-size:14px}',
    '.tp-fs-footer{display:flex;align-items:center;gap:14px;position:sticky;bottom:0;z-index:5;flex:0 0 auto;padding:10px 15px;padding-bottom:calc(10px + env(safe-area-inset-bottom));background:#fff;border-top:1px solid #e5e5e5;box-shadow:0 -4px 12px rgba(0,0,0,.06)}',
    '.tp-fs-footer .tp-fs-footer__clear{flex:0 0 auto;min-width:0;min-height:44px;margin:0;padding:0 4px;border:0;background:none;color:#222;font-size:14px;font-weight:600;text-decoration:underline;text-underline-offset:3px;text-transform:none;letter-spacing:0}',
    '.tp-fs-footer .tp-fs-footer__clear[hidden]{display:none}',
    '.tp-fs-footer .tp-fs-footer__show{flex:1 1 auto;min-height:48px;margin:0;padding:0 16px;border:0;border-radius:4px;background:#222;color:#fff;font-size:15px;font-weight:600;text-transform:none;letter-spacing:0}',
    '.tp-fs-footer .tp-fs-footer__show[disabled]{opacity:.7}',
    '.tp-fs-typing .tp-fs-footer{display:none}',
    '.tp-fs-typing form.t4s-facets__form{padding-bottom:70vh}',
    '.tp-fs-loading form.t4s-facets__form{opacity:.55;pointer-events:none;transition:opacity .15s}',
    '}'
  ].join('');

  function addStyle() {
    if (document.getElementById('tp-fs-style')) return;
    var s = document.createElement('style');
    s.id = 'tp-fs-style';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function esc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* Letters and digits only, lower case, accents removed, with a map back
     to positions in the original text so the match can be highlighted. */
  function fold(str) {
    var out = '', map = [];
    for (var i = 0; i < str.length; i++) {
      var ch = str[i].normalize ? str[i].normalize('NFD') : str[i]; /* accents split off, then dropped below */
      ch = ch.toLowerCase();
      for (var k = 0; k < ch.length; k++) {
        if (/[a-z0-9]/.test(ch[k])) { out += ch[k]; map.push(i); }
      }
    }
    return { s: out, map: map };
  }

  /* "mcdonald" also finds MacDonald, "mackay" also finds McKay. */
  function variants(q) {
    var f = fold(q).s;
    if (!f) return [];
    var v = [f];
    if (f.indexOf('mc') === 0) v.push('mac' + f.slice(2));
    else if (f.indexOf('mac') === 0) v.push('mc' + f.slice(3));
    return v;
  }

  function findMatch(text, vars) {
    var f = fold(text);
    for (var i = 0; i < vars.length; i++) {
      var at = f.s.indexOf(vars[i]);
      if (at > -1) return { start: f.map[at], end: f.map[at + vars[i].length - 1] + 1 };
    }
    return null;
  }

  /* Wrap the value's own text (not the tick box or the count) in a span. */
  function labelOf(a) {
    if (!a) return null;
    var nodes = a.childNodes;
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim()) {
        var raw = n.nodeValue, lead = raw.match(/^\s*/)[0], trail = raw.match(/\s*$/)[0];
        var span = document.createElement('span');
        span.className = 'tp-fs__label';
        span.textContent = raw.trim();
        var frag = document.createDocumentFragment();
        if (lead) frag.appendChild(document.createTextNode(lead));
        frag.appendChild(span);
        if (trail) frag.appendChild(document.createTextNode(trail));
        a.replaceChild(frag, n);
        return span;
      }
    }
    return null;
  }

  /* Change text only when it differs, so the page observer stays quiet. */
  function setText(el, text, ico) {
    var key = (ico || '') + '|' + text;
    if (el.__tpText === key) return;
    el.__tpText = key;
    if (ico) el.innerHTML = '<span class="tp-fs__more-ico" aria-hidden="true">' + ico + '</span>' + esc(text);
    else el.textContent = text;
  }

  /* Values the theme greys out (0 products with the current filters) are
     left out of the list, except while searching. */
  function apply(box) {
    var q = box.input.value, vars = variants(q), searching = vars.length > 0;
    var total = box.items.length;
    var usable = box.items.filter(function (it) { return !it.li.classList.contains('is--disabled'); }).length;
    var limit = isPhone() ? SHOW_PHONE : SHOW_DESKTOP;
    var isLong = usable - limit >= 2;
    var open = !!expanded[box.key];
    var cutting = !searching && !open && isLong;
    var shown = 0, lastVisible = null, n = 0;
    for (var i = 0; i < total; i++) {
      var it = box.items[i];
      var off = it.li.classList.contains('is--disabled');
      var m = searching ? findMatch(it.text, vars) : null;
      var match = searching ? !!m : !off;
      var cut = cutting && match && n >= limit && !it.li.classList.contains('is--selected');
      if (!searching && !off) n++;
      it.li.classList.toggle('tp-fs-hide', !match);
      it.li.classList.toggle('tp-fs-cut', match && cut);
      it.li.classList.remove('tp-fs-fade');
      if (match) shown++;
      if (match && !cut) lastVisible = it.li;
      if (it.span) {
        var html = m
          ? esc(it.text.slice(0, m.start)) + '<mark class="tp-fs-hl">' + esc(it.text.slice(m.start, m.end)) + '</mark>' + esc(it.text.slice(m.end))
          : esc(it.text);
        if (it.html !== html) { it.span.innerHTML = html; it.html = html; }
      }
    }
    if (cutting && lastVisible && !lastVisible.classList.contains('is--selected')) lastVisible.classList.add('tp-fs-fade');
    box.more.hidden = searching || !isLong;
    box.more.setAttribute('aria-expanded', open ? 'true' : 'false');
    setText(box.more, open ? 'Show less' : 'Show all ' + usable, open ? '&minus;' : '+');
    box.clear.hidden = !q;
    setText(box.count, searching && shown ? shown + ' of ' + total : '');
    box.empty.hidden = !(searching && !shown);
    setText(box.empty, searching && !shown ? 'No match for "' + q.trim() + '"' : '');
  }

  /* Keep every copy of the same group (sidebar and drawers) in step. */
  function each(key, fn) {
    boxes = boxes.filter(function (b) { return b.ul.isConnected; });
    boxes.forEach(function (b) { if (b.key === key) fn(b); });
  }

  function sync(key, value) {
    queries[key] = value;
    each(key, function (b) {
      if (b.input.value !== value) b.input.value = value;
      apply(b);
    });
  }

  function scrollParent(el) {
    for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      var oy = getComputedStyle(p).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight) return p;
    }
    return null;
  }

  /* On phones, lift the group to the top of the drawer so the matches stay
     above the keyboard. */
  function liftGroup(el) {
    var facet = el.closest('.t4s-facet') || el;
    var sc = scrollParent(facet);
    if (!sc) return;
    sc.scrollTop = sc.scrollTop + facet.getBoundingClientRect().top - sc.getBoundingClientRect().top - 8;
  }

  function setup(ul) {
    ul.setAttribute('data-tp-fs', '');
    var lis = [].filter.call(ul.children, function (n) { return n.tagName === 'LI'; });
    if (lis.length < MIN_VALUES) return false;

    var facet = ul.closest('.t4s-facet');
    var titleEl = facet && facet.querySelector('.t4s-facet-title');
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    var key = title || 'filter';

    var items = lis.map(function (li) {
      var a = li.querySelector('a');
      var span = labelOf(a);
      var text = span ? span.textContent : '';
      if (!span && a) {
        var c = a.querySelector('.t4s-value-count');
        text = a.textContent.replace(c ? c.textContent : '', '').replace(/\s+/g, ' ').trim();
      }
      return { li: li, span: span, text: text };
    });
    if (!items.some(function (it) { return it.text; })) return false;

    if (!ul.id) ul.id = 'tp-fs-list-' + (++uid);
    ul.classList.add('tp-fs-list');

    var noun = !title ? 'options' : /s$/i.test(title) ? title : title + (title === title.toUpperCase() ? 'S' : 's');
    var wrap = document.createElement('div');
    wrap.className = 'tp-fs';
    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'tp-fs__input';
    input.placeholder = 'Search ' + noun;
    input.setAttribute('aria-label', 'Search ' + noun);
    input.setAttribute('aria-controls', ul.id);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('enterkeyhint', 'search');
    input.spellcheck = false;
    var clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'tp-fs__clear';
    clear.setAttribute('aria-label', 'Clear search');
    clear.innerHTML = '&times;';
    clear.hidden = true;
    wrap.appendChild(input);
    wrap.appendChild(clear);
    var count = document.createElement('p');
    count.className = 'tp-fs__count';
    count.setAttribute('aria-live', 'polite');
    var empty = document.createElement('p');
    empty.className = 'tp-fs__empty';
    empty.hidden = true;
    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'tp-fs__more';
    more.setAttribute('aria-controls', ul.id);

    ul.parentNode.insertBefore(wrap, ul);
    ul.parentNode.insertBefore(count, ul);
    ul.parentNode.insertBefore(more, ul.nextSibling);
    ul.parentNode.insertBefore(empty, ul.nextSibling);

    var box = { ul: ul, input: input, clear: clear, count: count, empty: empty, more: more, key: key, items: items };
    var escUsed = false;
    boxes.push(box);

    input.addEventListener('input', function (e) {
      e.stopPropagation();
      sync(key, input.value);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        var vis = items.filter(function (it) { return !it.li.classList.contains('tp-fs-hide') && !it.li.classList.contains('is--disabled'); });
        if (variants(input.value).length && vis.length === 1) {
          var a = vis[0].li.querySelector('a');
          if (a) {
            if (!isPhone()) {
              var mine = refocus = { key: key, scope: scopeOf(input) };
              setTimeout(function () { if (refocus === mine) refocus = null; }, 4000);
            }
            a.click();
          }
        }
        if (isPhone()) input.blur();
      } else if ((e.key === 'Escape' || e.key === 'Esc') && input.value) {
        e.preventDefault();
        e.stopPropagation();
        escUsed = true;
        sync(key, '');
      }
    });
    /* The theme closes drawers on Escape; keep the drawer when Escape only
       cleared the search. */
    input.addEventListener('keyup', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && escUsed) {
        e.preventDefault();
        e.stopPropagation();
      }
      escUsed = false;
    });
    input.addEventListener('focus', function () {
      if (!isPhone()) return;
      var d = input.closest('.t4s-drawer');
      if (d) d.classList.add('tp-fs-typing');
      setTimeout(function () { liftGroup(input); }, 300);
    });
    input.addEventListener('blur', function () {
      var d = input.closest('.t4s-drawer');
      if (d) d.classList.remove('tp-fs-typing');
    });
    clear.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      sync(key, '');
      input.focus();
    });
    more.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var closing = !!expanded[key];
      expanded[key] = !closing;
      each(key, apply);
      if (closing) {
        var t = (facet || ul).getBoundingClientRect().top;
        if (t < 0) liftGroup(ul);
      }
    });

    if (queries[key]) input.value = queries[key];
    apply(box);

    /* After Enter applied a value, the theme redraws the filters:
       put the cursor back in the visible box (computers only). */
    if (refocus && refocus.key === key && onScreen(input) &&
        (refocus.scope.isConnected ? refocus.scope.contains(input) : true)) {
      refocus = null;
      try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
    }
    return true;
  }

  /* ---------- Phones: keep the drawer open and add a results bar ---------- */

  function keepOpen() {
    keepOpenOnce = true;
    setTimeout(function () { keepOpenOnce = false; }, 1500);
  }

  function patchFacets() {
    var el = document.querySelector('.t4s-section-main [data-ntajax-options]');
    var F = el && el.Facets;
    if (!F || F.__tpKeepOpen || typeof F.closeDrawer !== 'function') return;
    var orig = F.closeDrawer;
    F.closeDrawer = function (a) {
      var node = a && a.jquery ? a[0] : a;
      var inDrawerForm = node && node.closest && node.closest('.t4s-drawer form.t4s-facets__form');
      if (keepOpenOnce || (isPhone() && inDrawerForm)) {
        keepOpenOnce = false;
        return;
      }
      return orig.apply(this, arguments);
    };
    F.__tpKeepOpen = true;
  }

  function startLoading(drawer) {
    if (!drawer) return;
    drawer.classList.add('tp-fs-loading');
    updateFooters();
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(stopLoading, 6000);
  }

  function stopLoading() {
    clearTimeout(loadingTimer);
    var ds = document.querySelectorAll('.tp-fs-loading');
    for (var i = 0; i < ds.length; i++) ds[i].classList.remove('tp-fs-loading');
    updateFooters();
  }

  function clearUrl() {
    var keep = [];
    var parts = location.search.replace(/^\?/, '').split('&');
    for (var i = 0; i < parts.length; i++) {
      var k = decodeURIComponent((parts[i].split('=')[0] || '').replace(/\+/g, ' '));
      if (parts[i] && k.indexOf('filter.') !== 0 && k !== 'page') keep.push(parts[i]);
    }
    return location.pathname + (keep.length ? '?' + keep.join('&') : '');
  }

  function clearAll(drawer) {
    var bar = document.querySelector('.t4s-active-filters');
    var url = clearUrl();
    if (!bar) { location.href = url; return; }
    var a = document.createElement('a');
    a.href = url;
    a.style.display = 'none';
    bar.appendChild(a);
    keepOpen();
    startLoading(drawer);
    a.click();
    setTimeout(function () { if (a.parentNode) a.parentNode.removeChild(a); }, 0);
  }

  function ensureFooters() {
    if (!isPhone()) return;
    var ds = document.querySelectorAll('.t4s-drawer');
    for (var i = 0; i < ds.length; i++) {
      (function (d) {
        if (!d.querySelector('form.t4s-facets__form') || d.querySelector('.tp-fs-footer')) return;
        var host = d.querySelector('.t4s-drawer__content') || d;
        var f = document.createElement('div');
        f.className = 'tp-fs-footer';
        f.innerHTML = '<button type="button" class="tp-fs-footer__clear" hidden>Clear all</button>' +
          '<button type="button" class="tp-fs-footer__show">Show products</button>';
        host.appendChild(f);
        f.querySelector('.tp-fs-footer__show').addEventListener('click', function () {
          var c = d.querySelector('[data-drawer-close]');
          if (c) c.click();
        });
        f.querySelector('.tp-fs-footer__clear').addEventListener('click', function () { clearAll(d); });
      })(ds[i]);
    }
  }

  function updateFooters() {
    var fs = document.querySelectorAll('.tp-fs-footer');
    if (!fs.length) return;
    var c = document.querySelector('.t4s-active-filters__count .cp, .t4s-active-filters__count');
    var n = c ? parseInt(c.textContent.replace(/[^0-9]/g, ''), 10) : NaN;
    for (var i = 0; i < fs.length; i++) {
      var d = fs[i].closest('.t4s-drawer');
      var loading = !!(d && d.classList.contains('tp-fs-loading'));
      var active = !!(d && d.querySelector('form.t4s-facets__form li.is--selected')) || !!document.querySelector('.t4s-active-filters__remove-filter');
      var show = fs[i].querySelector('.tp-fs-footer__show');
      if (show.disabled !== loading) show.disabled = loading;
      setText(show, loading ? 'Updating...' : (active && !isNaN(n)) ? 'Show ' + n + (n === 1 ? ' product' : ' products') : 'Show products');
      var clr = fs[i].querySelector('.tp-fs-footer__clear');
      if (clr.hidden !== (!active || loading)) clr.hidden = !active || loading;
    }
  }

  /* ---------- Run ---------- */

  function enhance() {
    patchFacets();
    ensureFooters();
    var lists = document.querySelectorAll(LIST_SEL + ':not([data-tp-fs])');
    var fresh = lists.length > 0;
    for (var i = 0; i < lists.length; i++) {
      try { setup(lists[i]); } catch (err) { if (window.console) console.warn('tp-filter-search', err); }
    }
    if (fresh && document.querySelector('.tp-fs-loading')) stopLoading();
    else updateFooters();
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; enhance(); }, 60);
  }

  function init() {
    addStyle();
    enhance();
    document.addEventListener('click', function (e) {
      if (!isPhone() || !e.target.closest) return;
      var a = e.target.closest('.t4s-drawer form.t4s-facets__form ' + LIST_SEL + ' a');
      if (a) startLoading(a.closest('.t4s-drawer'));
    }, true);
    if (phoneMQ) {
      var onChange = function () { boxes.forEach(apply); ensureFooters(); updateFooters(); };
      if (phoneMQ.addEventListener) phoneMQ.addEventListener('change', onChange);
      else if (phoneMQ.addListener) phoneMQ.addListener(onChange);
    }
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes.length) { schedule(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
